export type HeaderType =
    'Default' |
    'Simple' |
    'None';

export class HeaderTypes {
    public static readonly DEFAULT: HeaderType = 'Default';
    public static readonly SIMPLE: HeaderType = 'Simple';
    public static readonly NONE: HeaderType = 'None';
}
